export default __webpack_public_path__ + "static/media/quote-1.dd45b19e.svg";